import React, { useState, Fragment, useEffect } from 'react';
import Layout from '../../Layout/Layout';
// import DataTable from 'react-data-table-component';
import DataTable from "react-data-table-component";
import { useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { FaEye } from "react-icons/fa";
import { IoCheckmarkCircle } from "react-icons/io5";
import TicketModal from '../../Components/Modals/TicketModal';
import { getSupportTickets, replayTickets } from '../../actions/users';
import { toast } from 'react-toastify';

const SupportList = () => {


    const navigate = useNavigate();


    const [show, setShow] = useState(false);
    const [responsive, setresponsive] = useState(true);
    const [dater, setdates] = useState('');
    const [categoryList, setCategoryList] = useState([
        {supportCategoryName: "adjfajhsdf", status: 'active'},
        {supportCategoryName: "adjfajhsdf", status: 'active'},
        {supportCategoryName: "adjfajhsdf", status: 'active'},
        {supportCategoryName: "adjfajhsdf", status: 'active'},
      ]);
      const [error, setError] = useState({});
      const [updateData,setUpdateData] = useState({})
      const [ticketList,setTicketList] = useState([])
      const [replay,setreplay] = useState('')
      const [ disableStatus, setDisableStatus ] = useState(false);

    const modalfunc = () => setShow(true);
    const handleClose = () => {
      if(!disableStatus){
        setShow(false)
      }
    };


      
    
  

useEffect(()=> {
  getSupportList()
},[])


const getSupportList = async()=> {
  try {
    const getData = await getSupportTickets()
    
    setTicketList(getData.data)
  } catch (e) {
    console.error("getSupportList_error",e)
  }
}

    const columns = [
        {

            key: "Subject",
            name: "Subject",
            // className: "tokenId",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) =>(
                <p>{row?.subject}</p>
              ),

        },
        {
            key: "Status",
            name: "Status",
            // className: "Name",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) =>(
                <p>{row.replystatus == 'noreply' ? 'Pending' : 'Completed'}</p>
              ),

        },

        {
            key: "Action",
            name: "Action",
            // className: "action",
            width: 200,
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => {
                return (
                    <Fragment>
                        {
                            row.replystatus == 'noreply'
                            ?
                            <button
                            data-toggle="modal"
                            data-target="#update-template-modal"
                            className="btn btn-primary btn-sm"
                            onClick={() => { setUpdateData(row);setShow(true) }}
                            style={{ marginRight: '5px' }}
                        >
                            {/* <i className="fa fa-edit"></i> */}
                            {/* <i className="fa fa-eye"></i> */}
                            <FaEye />
                        </button>
                            
                            :
                            <button
                            className="btn btn-primary btn-sm"
                            

                            style={{ marginRight: '5px' }}
                        >
                            {/* <i className="fa fa-edit"></i> */}
                            {/* <i className="fa fa-eye"></i> */}
                            <IoCheckmarkCircle />
                        </button>
                        }
                        
                        
                    </Fragment>
                );
            }
        },
        // {
        //   key: "Hide/show",
        //   text: "Actions",
        //   className: "action",
        //   width: 200,
        //   align: "left",
        //   sortable: false,
        //   cell: record => {
        //       return (
        //       <Fragment>
        //          <input type="checkbox"

        //           // checked={isItemSelected(record.tokenOwnerDb._id)}
        //           // onChange={(e)=>{hideshow(e,record)}}
        //           />
        //        </Fragment>
        //     );
        //   }
        // },
    ];

    const fileDownloader = (URL) => {
        fetch(URL).then((response) => {
            response.blob().then((blob) => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.href = url;
                a.download = url;
                a.click();
            });
        })
    }
    
    const replaySupportTicket = async ()=> {
      try {
        setDisableStatus(true);
        const id = toast.loading('Sendin Message..')
        if(replay == '' || replay == undefined || replay == null){
          toast.update(id,{render:'Error message is Required',type:'error',autoClose:1000, isLoading: false,})
          // toast.error("Error message is Required")
        }else{
          let payload = {
            message : replay,
            id: updateData._id,
            email: updateData.userEmail,
            subject: updateData.subject
          }
          const sendReplay = await replayTickets(payload);
          if(sendReplay?.success){
            toast.update(id,{render:sendReplay.message,type:'success',autoClose:1000, isLoading: false,})
            // toast.success(sendReplay.message)
            setShow(false)
            setDisableStatus(false);
            await getSupportList()
          }
          else{
            toast.update(id,{render:sendReplay.message,type:'error',autoClose:1000, isLoading: false,})
            // toast.error(sendReplay.message)
            
          }
        }
      } catch (e) {
        console.error("replaySupportTicket_error",e)
      }
      setDisableStatus(false);
    }

    return (
        <>
            <Layout>
                <div className="supportticket">
                    <h1 className="pagehead">Support Ticket</h1>
                    <div className="cardbox">
                        <div className="tablebox">
                            {/* <Form.Control type="text" placeholder="Filter in records" /> */}
                            <DataTable
                                className='react-datatables'
                                columns={columns}
                                data={ticketList}
                                pagination // Enable pagination
                                // paginationPerPage={2} // Rows per page
                                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                            />
                        </div>
                    </div>
                </div>
            </Layout>

            <TicketModal replay={replay} replaySupportTicket={replaySupportTicket} fileDownloader={(url)=>fileDownloader(url)} setreplay={(msg)=>setreplay(msg)} updateData={updateData} show={show} handleClose={handleClose} disableStatus={disableStatus} />
        </>
    )
}

export default SupportList;